import React, { useState } from 'react';
import './App.css';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import FormularioTpp from './components/FormularioTpp';
import Header from './components/Header';
import Loading from './components/Loading';
import PaginaSucesso from './components/PaginaSucesso'; 
import PaginaDeErro from './components/PaginaDeErro'; 

const locales = {
  en: { title: 'English', img: "url('https://cdne-phusion-dev-03.azureedge.net/assets/img/icones/bandeiras/en-us.png')  no-repeat center center" },
  es: { title: 'Spanish', img: "url('https://cdne-phusion-dev-03.azureedge.net/assets/img/icones/bandeiras/es-es.png')  no-repeat center center" },
  ptBR: { title: 'Portuguese', img: "url('https://cdne-phusion-dev-03.azureedge.net/assets/img/icones/bandeiras/pt-br.png')  no-repeat center center" },
};

function App() {
  const { t, i18n } = useTranslation();
  const [currentPage, setCurrentPage] = useState('initial'); 
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleOpenForm = () => {
    setCurrentPage('form');
  };

  const handleCloseForm = () => {
    setCurrentPage('initial');
  };

  const handleFormSubmit = (isReadyToLoad) => {
    if (isReadyToLoad) {
      setIsLoading(true);
    }
  };

  const handleError = (message) => {
    setErrorMessage(message); 
    setIsLoading(false);
    setCurrentPage('error');
  };

  const handleSuccess = () => {
    setIsLoading(false);
    setCurrentPage('success');
  };

  return (
    <div className="App">
      {['form', 'success', 'error'].includes(currentPage) && <Header />}

      {isLoading ? (
        <Loading />
      ) : currentPage === 'form' ? (
        <FormularioTpp onClose={handleCloseForm} onReady={handleFormSubmit} onError={handleError}  onSuccess={handleSuccess} />
      ) : currentPage === 'success' ? (
        <PaginaSucesso />
      ) : currentPage === 'error' ? (
        <PaginaDeErro message={errorMessage} />
      ) : (
        <>
          <ul className="App-countries">
            {Object.keys(locales).map((locale) => (
              <button
                key={locale}
                style={{
                  fontWeight: i18n.resolvedLanguage === locale ? 'bold' : 'normal',
                  background: locales[locale].img,
                  backgroundSize: '25px 25px',
                  padding: '8px 10px',
                  borderRadius: 12,
                  width: '26px',
                  height: '25px',
                  marginLeft: '2px',
                  opacity: i18n.resolvedLanguage === locale ? '1.0' : '0.3',
                  borderWidth: 0,
                }}
                type="button"
                onClick={() => i18n.changeLanguage(locale)}
              />
            ))}
          </ul>
          <p>{t('main.label-Criar-Conta')}</p>
          <button className="cadastre" onClick={handleOpenForm}>
            {t('main.botao-cadastre')}
          </button>
        </>
      )}
    </div>
  );
}

export default function WrappedApp() {
  return (
    <Suspense fallback="...loading">
      <App />
    </Suspense>
  );
}
